const styles = theme => ({
  metricsPage: {
    maxWidth: '1160px',
    margin: '0 auto',
    paddingBottom: '32px',
  },
  metricsPageTitle: {
    color: '#0b2452',
    fontSize: '26px',
    fontWeight: 700,
  },
  metricsFilters: {
    padding: '18px',
    border: '1px solid #dce3ee',
    borderTop: '4px solid #0757a3',
    borderRadius: '7px',
    background: '#fff',
    boxShadow: '0 2px 5px rgba(14, 41, 82, 0.13)',
  },
  metricsResults: {
    '& .spectrum-Heading': {
      color: '#102653',
      fontWeight: 700,
    },
  },
  applyButton: {
    minHeight: '30px',
    borderRadius: '3px',
    background: '#f15a24',
  },
  clearButton: {
    minHeight: '30px',
    borderRadius: '3px',
    borderColor: '#0757a3',
    color: '#0757a3',
  },
  grid3: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
  },
  grid4: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',
  },
  grid5: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: '12px',
  },
  gridAutoFit: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '16px',
  },
  gridAutoFill: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    gap: '16px',
  },
  technicianPill: {
    background: '#f0f0f0',
    borderRadius: '4px',
    padding: '4px 12px',
    fontSize: '13px',
  },
  metricCard: {
    background: '#fff',
    borderRadius: '6px',
    padding: '16px',
    boxShadow: '0 2px 5px rgba(14, 41, 82, 0.13)',
    border: '1px solid #dce3ee',
    borderTop: '4px solid #0757a3',
    transition: 'background-color 150ms ease, box-shadow 150ms ease',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
    '&:hover': {
      boxShadow: '0 5px 10px rgba(14, 41, 82, 0.2)',
    },
  },
  metricCardInner: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  metricCardLabel: {
    color: '#253860',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: 700,
  },
  metricCardValue: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#102653',
    lineHeight: 1,
  },
  metricCardUnitRow: {
    marginTop: '2px',
  },
  metricCardUnit: {
    color: '#999',
    fontSize: '10px',
  },
  dateRangeWarning: {
    color: '#d32f2f',
    fontSize: '13px',
    marginTop: '8px',
    marginBottom: '0',
  },
  metricsError: {
    color: '#d32f2f',
    display: 'block',
    marginTop: '12px',
  },
  testCountInfoIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    color: '#5f6b7a',
    lineHeight: 0,
  },
  testCountTooltip: {
    fontSize: '14px',
    lineHeight: 1.4,
  },
  cableTypeCard: {
    background: '#fff',
    borderRadius: '6px',
    padding: '16px',
    boxShadow: '0 2px 5px rgba(14, 41, 82, 0.13)',
    border: '1px solid #dce3ee',
    borderTop: '4px solid #0757a3',
    position: 'relative',
  },
  chartIconWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '8px',
  },
  chartIcon: {
    cursor: 'pointer',
    color: '#1565c0',
    '&:hover': {
      color: '#0d47a1',
    },
  },
  cableTypeRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
    padding: '6px 0',
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  cableTypeRowLabel: {
    flex: 1,
    color: '#666',
    fontSize: '13px',
  },
  cableTypeRowValue: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1,
    color: '#222',
  },
  cableTypeRowUnit: {
    color: '#999',
    fontSize: '12px',
    minWidth: '28px',
  },
  summaryCardTitle: {
    color: '#0757a3',
  },
  marginCard: {
    background: '#fff',
    borderRadius: '6px',
    padding: '16px',
    boxShadow: '0 2px 5px rgba(14, 41, 82, 0.13)',
    border: '1px solid #dce3ee',
    borderTop: '4px solid #0757a3',
  },
  marginCardMetric: {
    fontSize: '16px',
    fontWeight: 700,
    marginBottom: '12px',
  },
  marginCardRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
    padding: '6px 0',
    borderBottom: '1px solid #f0f0f0',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  marginCardRowLabel: {
    flex: 1,
    color: '#666',
    fontSize: '13px',
  },
  marginCardRowValue: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1,
    color: '#222',
  },
  marginCardRowUnit: {
    color: '#999',
    fontSize: '12px',
    minWidth: '24px',
  },
  progressDialogContent: {
    minWidth: '360px',
  },
  progressStage: {
    color: '#1f2937',
    fontWeight: 600,
  },
  progressTrack: {
    width: '100%',
    height: '10px',
    borderRadius: '999px',
    overflow: 'hidden',
    background: '#e3edf8',
  },
  progressFill: {
    height: '100%',
    background: 'linear-gradient(90deg, #1565c0 0%, #42a5f5 100%)',
    transition: 'width 0.3s ease',
  },
  progressMeta: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    color: '#5f6b7a',
    fontSize: '12px',
  },
  progressHint: {
    color: '#5f6b7a',
    fontSize: '12px',
  },
});

export const chartColors = {
  passed: '#4caf50',
  failed: '#f44336',
  total: '#1565c0',
  min: '#f44336',
  max: '#4caf50',
  average: '#1565c0',
  actual: '#9e9e9e',
};

export default styles;
